export default __webpack_public_path__ + "static/media/Cash-black.f135ae43.svg";